module.exports = __webpack_public_path__ + "assets/img/oren.5cc24011.jpg";